import React from "react";
import PropTypes from "prop-types";
import Utility from "app/horoscope/utility/utility";
import { tableStyleCompact, thStyleCompact, tdStyleCompact, sectionTitleStyle } from "./printTableStyles";

export default function PlanetAspectsTable({ planetData }) {
    return (
        <div>
            <div style={sectionTitleStyle}>
                ග්‍රහ උපස්ථාන හා නිවේදකත්වය
            </div>
            <table style={tableStyleCompact}>
                <thead>
                    <tr>
                        <th style={thStyleCompact}></th>
                        <th style={thStyleCompact}>ග්‍රහයා</th>
                        <th style={thStyleCompact}>නැකත</th>
                        <th style={thStyleCompact}>උප ග්‍රහ</th>
                        <th style={thStyleCompact}>තැන්පත් ග්‍රහයින්ගේ නැකත්වල ලැගුම්ගත්</th>
                        <th style={thStyleCompact}>තැන්පත් භාවය</th>
                        <th style={thStyleCompact}>අධිපතිගේ නැකත්වල ලැගුම්ගත්</th>
                        <th style={thStyleCompact}>අධිපති</th>
                    </tr>
                </thead>
                <tbody>
                    {planetData.map((row, idx) => (
                        <tr key={idx}>
                            <td style={tdStyleCompact}><p dangerouslySetInnerHTML={{ __html: `${Utility.getPlanetSymbol(row.planet)}` }} /></td>
                            <td style={tdStyleCompact}>{row.planet}</td>
                            <td style={tdStyleCompact}>{row.nekathaAdhipathi}</td>
                            <td style={tdStyleCompact}>{row.upaGraha}</td>
                            <td style={tdStyleCompact}>{row.nakAdipathiThenpathBhavaya}</td>
                            <td style={tdStyleCompact}>{row.thenpathBhavaya}</td>
                            <td style={tdStyleCompact}>{row.nakAdipathiAithiBhavaya}</td>
                            <td style={tdStyleCompact}>{row.aithiBhavaya}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

PlanetAspectsTable.propTypes = {
    planetData: PropTypes.array.isRequired,
};
